module.exports = __webpack_public_path__ + "static/media/IconPdf.e4c87eb1.svg";